// AI-CONTEXT: See docs/features/livereport2-period-selector.md
//
// Formats a LiveReports2 report's overall period (Start/End Timestamps) for
// display. No bounds = 'Alles' (the report shows all-time data).

import timestampToUI from '../../utils/timestampToUI'

/**
 * @param {import('../../types/LiveReports2').LiveReports2Doc} report
 * @returns {string} e.g. '01-01-2025 – 31-12-2025', 'Vanaf 01-06-2025' or 'Alles'
 */
const formatReportPeriod = (report) => {
    const start = report.Start ? timestampToUI(report.Start) : null
    const end = report.End ? timestampToUI(report.End) : null
    if (start && end) return `${start} – ${end}`
    if (start) return `Vanaf ${start}`
    if (end) return `Tot ${end}`
    return 'Alles'
}

export default formatReportPeriod
